import { GeoJsonLayer } from "@deck.gl/layers";
import { useSelector } from "react-redux";

export const ISOLINES_LAYER_ID = "isolinesLayer";

export default function IsolinesLayer() {
  const data = useSelector((state) => state.app.isoline.data);

  if (!data) {
    return null;
  }

  return new GeoJsonLayer({
    id: ISOLINES_LAYER_ID,
    data: {
      type: "FeatureCollection",
      features: [data],
    },
    stroked: true,
    filled: true,
    lineWidthMinPixels: 2,
    getFillColor: [71, 219, 153, 255 * 0.08],
    getLineColor: [71, 219, 153],
  });
}
